import { Star, Quote } from 'lucide-react';

const testimonials = [
  {
    name: 'Familie Müller',
    location: 'Zürich → München',
    rating: 5,
    text: 'Professionell, pünktlich und äusserst sorgfältig! Unser Umzug von Zürich nach München verlief absolut reibungslos. Die Zollabwicklung wurde komplett übernommen und alle Möbel kamen unbeschädigt an. Besonders beeindruckt hat uns die freundliche und kompetente Art des Teams.',
    date: 'März 2024',
  },
  {
    name: 'Thomas Schneider',
    location: 'Basel → Stuttgart',
    rating: 5,
    text: 'Nach drei Angeboten verschiedener Umzugsfirmen haben wir uns für diesen Service entschieden – und es war die richtige Wahl! Fixpreis ohne versteckte Kosten, schnelle Abwicklung und ein Team, das wirklich weiss, was es tut. Unser Klavier wurde mit grösster Sorgfalt transportiert.',
    date: 'Februar 2024',
  },
  {
    name: 'Andrea & Marco Weber',
    location: 'Bern → Berlin',
    rating: 5,
    text: 'Wir waren skeptisch, ob ein Umzug über 850 km so problemlos klappen würde. Aber vom ersten Besichtigungstermin bis zur Schlüsselübergabe war alles perfekt organisiert. Die Möbelmontage am Zielort war inklusive und das Team hat sogar geholfen, alles nach unseren Wünschen zu platzieren. Absolut empfehlenswert!',
    date: 'Januar 2024',
  },
  {
    name: 'Firma TechStart GmbH',
    location: 'Luzern → Frankfurt',
    rating: 5,
    text: 'Unser Büroumzug fand übers Wochenende statt, sodass unser Betrieb am Montag weiterlaufen konnte. Die Planung war detailliert, die Durchführung präzise. Besonders die sichere Verpackung unserer IT-Ausrüstung und Server war hervorragend. Bester Firmenumzugsservice, den wir je hatten!',
    date: 'Dezember 2023',
  },
  {
    name: 'Sarah Hofmann',
    location: 'St. Gallen → Hamburg',
    rating: 5,
    text: 'Als Alleinerziehende mit zwei Kindern war ich auf unkomplizierte Hilfe angewiesen. Das Team hat nicht nur transportiert, sondern auch beim Packen geholfen und die Kartons am Zielort wieder ausgepackt. Die Zollabwicklung lief völlig stressfrei. Preis-Leistung absolut top!',
    date: 'November 2023',
  },
  {
    name: 'Peter & Claudia Meier',
    location: 'Winterthur → Köln',
    rating: 5,
    text: 'Nach 30 Jahren in der Schweiz war unser Umzug nach Deutschland eine emotionale Angelegenheit. Das Team ist nicht nur fachlich kompetent, sondern auch menschlich sehr angenehm. Alles wurde mit Respekt behandelt – von Omas antikem Schrank bis zu unseren Kunstwerken. Danke für den grossartigen Service!',
    date: 'Oktober 2023',
  },
];

export default function Testimonials() {
  return (
    <section className="pt-32 pb-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <div className="inline-block bg-slate-100 text-slate-700 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Kundenstimmen
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Das sagen unsere Kunden
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            +2000 erfolgreiche Umzüge ins Ausland und hunderte zufriedene Kunden sprechen für sich.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-2xl p-8 relative border-2 border-slate-100 hover:border-slate-300 transition-all duration-300 hover:shadow-xl hover:-translate-y-2 group"
            >
              <Quote className="absolute top-6 right-6 w-12 h-12 text-slate-200 group-hover:text-slate-300 transition-colors duration-300" />

              <div className="flex items-center mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400 group-hover:scale-110 transition-transform duration-300" style={{transitionDelay: `${i * 50}ms`}} />
                ))}
              </div>

              <p className="text-slate-700 leading-relaxed mb-6 relative z-10">
                "{testimonial.text}"
              </p>

              <div className="border-t-2 border-slate-200 pt-4">
                <p className="font-bold text-slate-900">{testimonial.name}</p>
                <p className="text-sm text-slate-600">{testimonial.location}</p>
                <p className="text-xs text-slate-500 mt-1">{testimonial.date}</p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center bg-gradient-to-br from-slate-50 to-white rounded-2xl p-8 border-2 border-slate-100 max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold text-slate-900 mb-3">
            Ihr Umzug in professionellen Händen
          </h3>
          <p className="text-slate-600 mb-6">
            Jeder Umzug ist einzigartig – lassen Sie uns gemeinsam Ihre individuelle Lösung finden.
          </p>
          <button
            onClick={() => {
              const element = document.getElementById('kontakt');
              if (element) element.scrollIntoView({ behavior: 'smooth' });
            }}
            className="bg-slate-800 hover:bg-slate-900 text-white px-8 py-4 rounded-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-2xl hover:scale-105"
          >
            Jetzt kostenlose Beratung erhalten
          </button>
        </div>
      </div>
    </section>
  );
}
